import { Routes, Route } from "react-router-dom";
import "./index.css";
import Home from "./pages/Home";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/Footer";
import Articles from "./pages/articles/Articles";
import ArticleDetails from "./pages/articles/ArticleDetails";
import Achievement from "./pages/Achievement";
import Regulation from "./pages/Regulation";
import NotFound from "./pages/NotFound";
import Contact from "./pages/Contact";
import Publications from "./pages/Publications";
import Projet from "./pages/Projet";
import Gallery from "./pages/Gallery";
import Missions from "./pages/Missions";
import Cordonnateur from "./pages/Cordonnateur";
import Four from "./pages/Four";
import Goals from "./pages/Goals";
import Gestion from "./pages/Gestion";
import Moyens from "./pages/Moyens";
import Organigramme from "./pages/Organigramme";
import Promotion from "./pages/Promotion";
import Benifit from "./pages/Benifit";
import Team from "./pages/Team";
function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/actualites" element={<Articles />} />
        <Route path="/actualites/:slug" element={<ArticleDetails />} />
        <Route path="/realisations" element={<Achievement />} />
        <Route path="/regulations" element={<Regulation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projet" element={<Projet />} />
        <Route path="/rapport-et-publications" element={<Publications />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/missions" element={<Missions />} />
        <Route path="/cordonnateur" element={<Cordonnateur />} />
        <Route path="/four" element={<Four />} />
        <Route path="/objectifs" element={<Goals />} />
        <Route path="/commite-de-pilotage" element={<Gestion />} />
        <Route path="/unite-de-gestion" element={<Moyens />} />
        <Route path="/organigramme" element={<Organigramme />} />
        <Route path="/filieres-artisanales" element={<Promotion />} />
        <Route path="/benificiaires-du-pmn" element={<Benifit />} />
        <Route path="/equipe" element={<Team />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
